import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { ActionReducerMap } from '@ngrx/store';
import { AppState, APP_FEATURE_KEY, reducer } from './app.reducer';

export * from './app.reducer';

export interface State {
  [APP_FEATURE_KEY]: AppState;
  router: RouterReducerState<any>;
}

export const reducers: ActionReducerMap<State> = {
  [APP_FEATURE_KEY]: reducer,
  router: routerReducer,
};
